import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ServicehotelService } from 'src/app/api/config/servicehotel.service';
import AlertifyHelper from 'src/app/utils/utils';
import { constants } from 'src/app/constants';
import { ToolsService } from 'src/app/utils/tools.service';
import { GlobalService } from 'src/app/api/global.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { Router } from '@angular/router';
import { BookingsAmortizationExtendsComponent } from '../bookings-amortization-extends/bookings-amortization-extends.component';
import { BookingsCommissionExtendsComponent } from '../bookings-commission-extends/bookings-commission-extends.component';
declare var $: any;

@Component({
  selector: 'app-bookings-extends',
  templateUrl: './bookings-extends.component.html',
  styleUrls: ['./bookings-extends.component.css']
})
export class BookingsExtendsComponent {
  @ViewChild(BookingsAmortizationExtendsComponent) BookingsAmortizationExtendsComponent: any;
  @ViewChild(BookingsCommissionExtendsComponent) BookingsCommissionExtendsComponent: any;
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @Output() onSubmitEvent = new EventEmitter<string>();

  branchofficeSlug: string = '';
  item: FormGroup;
  submitted: boolean = false;

  // variables
  checkId:any = null;
  book: any = null;
  tours: any = [];
  hotels: any = [];
  movements: any = [];
  commissions: any = [];
  company: any = null;

  typevoucher_boleta: any = null;
  typevoucher_factura: any = null;
  typevoucher_income: any = null;
  typevoucher_expense: any = null;
  typevoucher_ordernote: any = null;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    public toolsService: ToolsService,
    private bookingsService: BookingsService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]]
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  focused() {
    setTimeout(() => {
      (<any>$('#item_description')).focus();
    }, 500);
  }

  init(booking_id: any) {
    this.LoadingModalComponent.show();

    this.typevoucher_boleta = this.toolsService.searchObjByKey(
      'BOLETA_ELECTRONICA',
      constants.SALE.VOUCHER
    );
    this.typevoucher_factura = this.toolsService.searchObjByKey(
      'FACTURA_ELECTRONICA',
      constants.SALE.VOUCHER
    );

    this.typevoucher_income = this.toolsService.searchObjByKey(
      'RECIBO_INGRESO',
      constants.SALE.VOUCHER
    );

    this.typevoucher_expense = this.toolsService.searchObjByKey(
      'RECIBO_EGRESO',
      constants.SALE.VOUCHER
    );
    this.typevoucher_ordernote = this.toolsService.searchObjByKey(
      'NOTA_PEDIDO',
      constants.SALE.VOUCHER
    );

    this.checkId = booking_id;
    this.editData();
   
  }

  edit(id: number) {
    (<any>$('#openBookingsExtends')).modal('hide');
    (<any>$('#openExtendsScheduleDetail')).modal('hide');
    setTimeout(() => {
      this.router.navigate([
        this.branchofficeSlug + '/reservas/reserva/editar',
        id
      ]);
    }, 50);
  }

  editData() {
    this.bookingsService.detail(this.checkId).subscribe({
      next: (data: any) => {
        let result = data.data;
        this.company = this.globalService.getCompany();
        this.book = result.book;
        this.tours = result.tours;
        this.hotels = result.hotels;
        this.movements = result.movements;
        this.commissions = result.commissions;
        this.LoadingModalComponent.hide();
      }
    });
  }

  bookingAmortization(book:any){
    book.company = this.company;
    this.BookingsAmortizationExtendsComponent.init(book);
  }

  bookingCommision(book:any){
    this.BookingsCommissionExtendsComponent.init(book);
  }

  beforeAmortization(data:any){
    this.editData();
    this.onSubmitEvent.emit(data);
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
    setTimeout(() => {
      this.book = null;
    }, 250);
  
  }

  close() {
    this.resetForm();
  }

}
